import { ClickOutsideController } from 'stimulus-use'
import * as focusTrap from 'focus-trap';

export default class extends ClickOutsideController {
    static targets = ['menubutton']
    focusTrap = null

    connect() {
        this.focusTrap = focusTrap.createFocusTrap(this.element, {
            escapeDeactivates: false,
            allowOutsideClick: true,
        });
    }

    toggleMenu() {
        if (document.body.classList.contains('show-menu')) {
            this.hideMenu();
        } else {
            this.showMenu();
        }
    }

    showMenu() {
        document.body.classList.add('show-menu');
        this.menubuttonTarget?.setAttribute('aria-expanded', 'true');
        this.focusTrap.activate();
    }

    hideMenu() {
        document.body.classList.remove('show-menu');
        this.menubuttonTarget?.setAttribute('aria-expanded', 'false');
        this.focusTrap.deactivate();
    }

    clickOutside() {
        this.hideMenu();
    }
}
